<template>
  <div class="drawer-wrapper">
    <el-drawer :wrapperClosable="true" :title="title" :visible.sync="isShowEdit" size="50%"
               :before-close="handleClose" direction="rtl">

      <div class="demo-drawer__content">
        <el-form :model="addForm" :rules="rules" ref="ruleForm">
          <el-row :gutter="35">

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="授权平台名称" prop="name" :label-width="formLabelWidth">
                <el-input v-model="addForm.name" placeholder="请输入授权平台名称" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="备注" prop="remark" :label-width="formLabelWidth">
                <el-input type="textarea"  v-model="addForm.remark" :autosize="{ minRows: 2, maxRows: 6}" placeholder="请输入备注" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="状态" prop="status" :label-width="formLabelWidth" style="width: 85%;">
                <el-radio-group v-model="addForm.status">
                  <el-radio :label="1">正常</el-radio>
                  <el-radio :label="0">禁用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="AddNone">取 消</el-button>
        <el-button type="primary" @click="addPush">确 定</el-button>
      </div>

    </el-drawer>
  </div>
</template>

<script>
import {MoneyManagementAPI} from '@/api/MoneyManagement/MoneyManagement';
import {processErrors} from "@/utils/errorHandler";

export default {
  props: ['isShowEdit', "editID"],
  components: {},
  data() {
    return {
      title: "新增",
      formLabelWidth: "140px",
      addForm: {
        name: "",
        remark: "",
        status: 1,
      }, 
      rules: {
        name: [
          {required: true, message: '请输入授权平台名称', trigger: 'blur'},
        ],
      },
    };
  },
  created() {

  },
  mounted() {
    this.addForm.id = this.editID
    if (this.editID != "") {
      this.title = "编辑"
      let api = MoneyManagementAPI()
      api.getAuthPlatformInfo(this.editID).then(res => {
        if (res.code == 0) {
          this.addForm = res.data
        } else {
          processErrors(res);
        }
      })
    }
  },
  methods: {
    handleClose(done) {
      this.$emit('NoneDlog');
      this.$refs['ruleForm'].resetFields();
    },

    AddNone() {
      this.addForm = {
        name: "",
        remark: "",
        status: 1,
      }
      this.title = ""
      this.$refs['ruleForm'].resetFields();
      this.$emit('NoneDlog');
    },

    addPush() {
      this.$refs['ruleForm'].validate(async (valid) => {
        if (valid) {
          let createText = ''
          let res
          let api = MoneyManagementAPI()

          if (this.addForm.id == "") {
            createText = "创建成功";
          } else {
            createText = "修改成功";
          }

          res = await api.authPlatformEdit(this.addForm)
          if (res.code == 0) {
            this.$message({
              message: createText,
              type: 'success'
            });
            this.$emit('AddOk');
          } else {
            processErrors(res);
          }
        } else {
          return false;
        }
      });

    }
  },
}
</script>
<style lang='scss' scoped>
.demo-drawer__content {
  height: calc(100% - 80px); /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto; /* 添加垂直滚动条 */
  margin-top: 20px;
  overflow-x: hidden;
}

.form-wrapper {
  padding-bottom: 80px; /* 给表单内容添加底部间距,留出按钮区域 */
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  margin: 0 10px;
  width: calc(50% - 20px);
}

::v-deep .el-drawer__close-btn {
  font-size: 30px;
  font-weight: bold;
}
</style>